/**
 * A configuration object to request custom capabilities when accessing a camera.
 */
export interface CameraSettings {
  /**
   * The preferred video fram resolution (not guaranteed to be precise depending on device, could be imprecise/lower).
   */
  readonly resolutionPreference: CameraSettings.ResolutionPreference;
}

export namespace CameraSettings {
  /**
   * Video frame resolution request (not guaranteed to be precise depending on device, could be imprecise/lower).
   */
  export enum ResolutionPreference {
    /**
     * Resolution of around 1080p (or less).
     */
    FULL_HD,
    /**
     * Resolution of around 720p (or less).
     */
    HD
  }
}
